import { render, staticRenderFns } from "./UserCustomFieldsTab.vue?vue&type=template&id=bc3d07fe&scoped=true&"
import script from "./UserCustomFieldsTab.vue?vue&type=script&lang=js&"
export * from "./UserCustomFieldsTab.vue?vue&type=script&lang=js&"
import style0 from "./UserCustomFieldsTab.vue?vue&type=style&index=0&id=bc3d07fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3d07fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VSkeletonLoader,VSwitch,VTextField})
